// utm_medium values to turn on anonymous tracking
const UTMS_ANONYMOUS_TRACKING = ['virality', 'email'];
export default UTMS_ANONYMOUS_TRACKING;